import { render, staticRenderFns } from "./EntryLinks.vue?vue&type=template&id=5bd97e4a&scoped=true&"
import script from "./EntryLinks.vue?vue&type=script&lang=js&"
export * from "./EntryLinks.vue?vue&type=script&lang=js&"
import style0 from "./EntryLinks.vue?vue&type=style&index=0&id=5bd97e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd97e4a",
  null
  
)

export default component.exports